
import { Wrapper, Status } from "@googlemaps/react-wrapper"
import { Map } from "./Map"
import env from "../../../env"
import { Marker } from "./MapMarker"
import { Box, Typography } from "@mui/material"

type Props = {
  date: string
  lat: number
  lng: number
}

const PictureInfo = (props: Props) => {
  const { date, lat, lng } = props
  const mapApiKey = env('GOOGLE_MAP_API_KEY') || ""

  const position = { lat, lng } as google.maps.LatLngLiteral

  const render = (status: Status) => {
    return <h1>{status}</h1>
  }

  return (
    <Box display="flex-col" width={200}>
      <Wrapper apiKey={mapApiKey} render={render}>
        <Map style={{ width: '100%', aspectRatio: '1 / 1' }} center={position}>
          <Marker position={position} />
        </Map>
      </Wrapper>
      <Typography className="text-center" sx={{ background: "white" }}>{date}</Typography>
    </Box>
  )
}

export default PictureInfo
